import { css } from '@emotion/react';
import { RefundSummary } from '@frontend/api-refunds';
import { useTranslation } from '@frontend/i18n';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { SummaryItem } from '../../SummaryItem/index';

export * from './date-filters';

export type RefundSummaryProps = {
  summary?: RefundSummary;
  loading: boolean;
  displayDateLabel?: string;
};

export const RefundSummaryCard = ({ summary, loading }: RefundSummaryProps) => {
  const { t } = useTranslation('payments');

  return (
    <>
      <div
        className='refunds-summary-card'
        css={css`
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          max-width: 720px;
          flex-wrap: wrap;
          @media (max-width: ${breakpoints.small.max}px) {
            margin-bottom: ${theme.spacing(0)};
            background-color: ${theme.colors.neutral[5]};
            border-top: 1px solid ${theme.colors.neutral[20]};
            border-bottom: 1px solid ${theme.colors.neutral[20]};
            padding: ${theme.spacing(2, 3)};
            gap: ${theme.spacing(1)};
          }
        `}
      >
        <SummaryItem
          label={t('Amount Refunded')}
          amount={summary?.totalAmount}
          loading={loading}
          infoText={t('Total amount refunded from your account. Active report filters will impact the displayed data.')}
          data-trackingid='pay-portal-invoices-btn-amountprocessedhint'
        />
      </div>
    </>
  );
};
